import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import ErrorPage from "./pages/ErrorPage";
import HomePage from "./pages/HomePage";
import DocsPage from "./pages/DocsPage";
import LoginPage from "./pages/LoginPage";
import NewsPage from "./pages/NewsPage";
import NewsPost from "./pages/NewsPost";
import ProductsPage from "./pages/ProductsPage";
import RegPage from "./pages/RegPage";
import SearchPage from "./pages/SearchPage";
import TrackingPage from "./pages/TrackingPage";
import ThingDelivery from "./pages/ThingsPage";
import CareerPage from "./pages/CareerPage";
import BusinessPage from "./pages/BusinessPage";
import ErrorApiPage from "./pages/ErrorApi";
import PageWrapper from "./pages/PageWrapper";
import MissionPage from "./pages/MissionPage";

export type RouteType = {
  path: string;
  component: any;
};

let routes: Array<RouteType> = [
  { path: "/career/culture/", component: <MissionPage /> },
  { path: "/ru/career/culture/", component: <MissionPage /> },
  { path: "/en/career/culture/", component: <MissionPage /> },

  { path: "/ru/for-you/", component: <ThingDelivery /> },
  { path: "/ru/for-you/:params/", component: <ThingDelivery /> },

  { path: "/ru/offices/", component: <ThingDelivery /> },
  { path: "/ru/for-you/services/", component: <ThingDelivery /> },
  { path: "/ru/for-you/tariffs/", component: <ThingDelivery /> },
  { path: "/ru/for-you/customs-clearance/", component: <ThingDelivery /> },
  { path: "/ru/for-you/accompanying-documents/", component: <ThingDelivery /> },
  { path: "/ru/for-you/faq/", component: <ThingDelivery /> },

  { path: "/ru/for-business/", component: <BusinessPage /> },
  { path: "/ru/for-business/:params/", component: <BusinessPage /> },

  { path: "/ru/for-business/services/", component: <BusinessPage /> },
  { path: "/ru/for-business/tariffs/", component: <BusinessPage /> },
  { path: "/ru/for-business/customs-clearance/", component: <BusinessPage /> },
  {
    path: "/ru/for-business/accompanying-documents/",
    component: <BusinessPage />,
  },
  { path: "/ru/for-business/faq/", component: <BusinessPage /> },

  { path: "/ru/", component: <HomePage /> },
  { path: "/ru/about", component: <AboutPage /> },
  { path: "/ru/track", component: <TrackingPage /> },
  { path: "/ru/login", component: <LoginPage /> },
  { path: "/ru/reg", component: <RegPage /> },
  { path: "/ru/contact", component: <ContactPage /> },
  { path: "/ru/news", component: <NewsPage /> },
  { path: "/ru/products-services", component: <ProductsPage /> },
  { path: "/ru/news/:id", component: <NewsPost /> },
  { path: "/ru/search", component: <SearchPage /> },
  { path: "/ru/error", component: <ErrorPage /> },
  { path: "/ru/things-of-home", component: <ErrorPage /> },
  { path: "/ru/global-delivery", component: <ErrorPage /> },
  { path: "/ru/career", component: <CareerPage /> },
  { path: "/ru/:param", component: <DocsPage /> },

  { path: "/en/for-you/", component: <ThingDelivery /> },
  { path: "/en/for-you/:params/", component: <ThingDelivery /> },

  { path: "/en/offices/", component: <ThingDelivery /> },
  { path: "/en/for-you/services/", component: <ThingDelivery /> },
  { path: "/en/for-you/tariffs/", component: <ThingDelivery /> },
  { path: "/en/for-you/customs-clearance/", component: <ThingDelivery /> },
  { path: "/en/for-you/accompanying-documents/", component: <ThingDelivery /> },
  { path: "/en/for-you/faq/", component: <ThingDelivery /> },

  { path: "/en/for-business/", component: <BusinessPage /> },
  { path: "/en/for-business/:params/", component: <BusinessPage /> },

  { path: "/en/for-business/services/", component: <BusinessPage /> },
  { path: "/en/for-business/tariffs/", component: <BusinessPage /> },
  { path: "/en/for-business/customs-clearance/", component: <BusinessPage /> },
  {
    path: "/en/for-business/accompanying-documents/",
    component: <BusinessPage />,
  },
  { path: "/en/for-business/faq/", component: <BusinessPage /> },

  { path: "/en/", component: <HomePage /> },
  { path: "/en/about", component: <AboutPage /> },
  { path: "/en/track", component: <TrackingPage /> },
  { path: "/en/login", component: <LoginPage /> },
  { path: "/en/reg", component: <RegPage /> },
  { path: "/en/contact", component: <ContactPage /> },
  { path: "/en/news", component: <NewsPage /> },
  { path: "/en/products-services", component: <ProductsPage /> },
  { path: "/en/news/:id", component: <NewsPost /> },
  { path: "/en/search", component: <SearchPage /> },
  { path: "/en/error", component: <ErrorPage /> },
  { path: "/en/things-of-home", component: <ErrorPage /> },
  { path: "/en/global-delivery", component: <ErrorPage /> },
  { path: "/en/career", component: <CareerPage /> },
  { path: "/en/:param", component: <DocsPage /> },
  { path: "/for-you/", component: <ThingDelivery /> },
  { path: "/for-you/:params/", component: <ThingDelivery /> },
  { path: "/offices/", component: <ThingDelivery /> },
  { path: "/for-you/services/", component: <ThingDelivery /> },
  { path: "/for-you/tariffs/", component: <ThingDelivery /> },
  { path: "/for-you/customs-clearance/", component: <ThingDelivery /> },
  { path: "/for-you/accompanying-documents/", component: <ThingDelivery /> },
  { path: "/for-you/faq/", component: <ThingDelivery /> },

  { path: "/for-business/", component: <BusinessPage /> },
  { path: "/for-business/:params/", component: <BusinessPage /> },

  { path: "/for-business/services/", component: <BusinessPage /> },
  { path: "/for-business/tariffs/", component: <BusinessPage /> },
  { path: "/for-business/customs-clearance/", component: <BusinessPage /> },
  {
    path: "/for-business/accompanying-documents/",
    component: <BusinessPage />,
  },
  { path: "/for-business/faq/", component: <BusinessPage /> },

  { path: "/", component: <HomePage /> },
  { path: "/about", component: <AboutPage /> },
  { path: "/track", component: <TrackingPage /> },
  { path: "/login", component: <LoginPage /> },
  { path: "/reg", component: <RegPage /> },
  { path: "/contact", component: <ContactPage /> },
  { path: "/news", component: <NewsPage /> },
  { path: "/products-services", component: <ProductsPage /> },
  { path: "/news/:id", component: <NewsPost /> },
  { path: "/search", component: <SearchPage /> },
  { path: "/error", component: <ErrorPage /> },
  { path: "/error-api", component: <ErrorApiPage /> },
  { path: "/en/error-api", component: <ErrorApiPage /> },
  { path: "/ru/error-api", component: <ErrorApiPage /> },

  { path: "/things-of-home", component: <ErrorPage /> },
  { path: "/global-delivery", component: <ErrorPage /> },
  { path: "/career", component: <CareerPage /> },
  { path: "/:param", component: <DocsPage /> },
];

routes = routes.map((c: any) => {
  c.component = <PageWrapper page={c.component} />;
  return c;
});

export default routes;
